<div class="loader">
  <i class="fad fa-arrow-up"></i>
  <i class="fad fa-cloud"></i>
  <i class="fad fa-arrow-down"></i>
</div>